import { useMemo } from 'react'
import DateHelpers from 'helpers/date_helpers'

const BASE_STEPS_CONFIG = [
  {
    key: 'signed_up',
    title: 'Sign Up',
    description: 'Your friend joins Swipecast by your referral link.',
  },
  {
    key: 'user_approved',
    title: 'Get Approved',
    description: 'Your friend gets successfully off the waitlist.',
  },
  {
    key: 'first_activity',
    matchKeys: ['job_created', 'applied_to_job'],
    title: 'Make the First Move',
    description: 'Your friend creates a project or applies to their first job on the platform.',
  },
  {
    key: 'job_completed',
    title: 'Complete a Job',
    description: "Your friend's first job is successfully completed.",
  },
]

const LAST_STEP_CONFIG = {
  payout_paid: {
    key: 'payout_paid',
    title: 'Get a Reward',
    description: 'You receive a referral fee on your balance.',
  },
  payout_failed: {
    key: 'payout_failed',
    title: 'Payout Failed',
    description: 'The payout could not be processed. Please check your payment settings.',
  },
}

function buildStepsWithStatus(ledger) {
  const ledgerMap = {}
  ledger.forEach(item => {
    ledgerMap[item.new_status] = item.timestamp
  })

  const hasPayoutFailed = !!ledgerMap['payout_failed']
  const lastStepKey = hasPayoutFailed ? 'payout_failed' : 'payout_paid'
  const stepsConfig = [...BASE_STEPS_CONFIG, LAST_STEP_CONFIG[lastStepKey]]

  const steps = stepsConfig.map((step, index) => {
    const keysToCheck = step.matchKeys || [step.key]
    const matchedKey = keysToCheck.find(key => ledgerMap[key])
    const timestamp = matchedKey ? ledgerMap[matchedKey] : null
    const isCompleted = !!timestamp
    return {
      ...step,
      index: index + 1,
      isCompleted,
      date: DateHelpers.timestampRangeLabel(timestamp ? [timestamp] : []),
    }
  })

  return steps.map((step, index) => ({
    ...step,
    isNext: !step.isCompleted && index > 0 && steps[index - 1].isCompleted,
    isFailed: step.key === 'payout_failed' && step.isCompleted,
  }))
}

function useReferralTimelineSteps(ledger = []) {
  return useMemo(() => buildStepsWithStatus(ledger), [ledger])
}

export default useReferralTimelineSteps
